import { STATUS_COLORS } from '../../pages/Workboard/common/constants';
import { ModelStatus } from '../../pages/Workboard/common/types';

// Calendar localStorage keys
export const CALENDAR_DATE_KEY = 'modelsCalendarDate';
export const CALENDAR_VIEW_KEY = 'modelsCalendarView';
export const CALENDAR_COLOR_PALETTE_KEY = 'modelsCalendarColorPalette';
export const CALENDAR_COLOR_PRESETS_KEY = 'modelsCalendarColorPresets';

// Calendar view options
export const CALENDAR_VIEWS = ['month', 'week'] as const;
export const DEFAULT_CALENDAR_VIEW = 'month' as const;

// Calendar date format (moment format)
export const CALENDAR_DATE_FORMAT = 'YYYY-MM-DD';

// Calendar event colors by status
export const MODELS_CALENDAR_EVENT_COLORS = {
  DRAFT: STATUS_COLORS[ModelStatus.DRAFT],
  REVIEW: STATUS_COLORS[ModelStatus.REVIEW],
  IN_PROCESS_SCALAR_USA: STATUS_COLORS[ModelStatus.IN_PROCESS_SCALAR_USA],
  FINAL: STATUS_COLORS[ModelStatus.FINAL],
  COMPLETE: STATUS_COLORS[ModelStatus.COMPLETE],
  WAITING: STATUS_COLORS[ModelStatus.WAITING],
  DEFAULT: '#3174ad', // Default blue
} as const;

// Models Calendar status mapping (matches Fulfillment.model_status enum values)
export const MODELS_CALENDAR_STATUS_COLOR_MAP: Record<number, string> = {
  0: STATUS_COLORS[ModelStatus.DRAFT],
  1: STATUS_COLORS[ModelStatus.REVIEW],
  2: STATUS_COLORS[ModelStatus.IN_PROCESS_SCALAR_USA],
  3: STATUS_COLORS[ModelStatus.FINAL],
  4: STATUS_COLORS[ModelStatus.COMPLETE],
  5: STATUS_COLORS[ModelStatus.WAITING],
};

// Calendar event text colors by status
export const MODELS_CALENDAR_EVENT_TEXT_COLORS = {
  DRAFT: '#000000',
  REVIEW: '#000000',
  IN_PROCESS: '#FFFFFF',
  FINAL: '#FFFFFF',
  COMPLETE: '#FFFFFF',
  WAITING: '#000000',
  DEFAULT: '#FFFFFF',
} as const;

// Calendar status text color mapping (matches Fulfillment.model_status enum values)
export const MODELS_CALENDAR_STATUS_TEXT_COLOR_MAP: Record<number, string> = {
  0: MODELS_CALENDAR_EVENT_TEXT_COLORS.DRAFT,
  1: MODELS_CALENDAR_EVENT_TEXT_COLORS.REVIEW,
  2: MODELS_CALENDAR_EVENT_TEXT_COLORS.IN_PROCESS,
  3: MODELS_CALENDAR_EVENT_TEXT_COLORS.FINAL,
  4: MODELS_CALENDAR_EVENT_TEXT_COLORS.COMPLETE,
  5: MODELS_CALENDAR_EVENT_TEXT_COLORS.WAITING,
};

// Calendar messages
export const CALENDAR_MESSAGES = {
  NO_DUE_DATES: 'No models with due dates found',
  UNKNOWN_COMPANY: 'Unknown Company',
} as const;

// Calendar styles
export const CALENDAR_STYLES = {
  HEIGHT: '100%',
  MIN_HEIGHT: '600px',
  EVENT_BORDER_RADIUS: '5px',
  EVENT_OPACITY: 0.8,
  EVENT_BORDER: '0px',
} as const;

// Base event styles (fixed styles for calendar events)
export const CALENDAR_EVENT_BASE_STYLES = {
  borderRadius: CALENDAR_STYLES.EVENT_BORDER_RADIUS,
  border: CALENDAR_STYLES.EVENT_BORDER,
  display: 'block',
  fontSize: '0.875rem',
  padding: '3px 5px',
  lineHeight: '1.3',
  fontWeight: 500,
  cursor: 'move',
} as const;

// Default color palette (for fallback)
export const DEFAULT_CALENDAR_COLOR_PALETTE = {
  DRAFT: STATUS_COLORS[ModelStatus.DRAFT],
  REVIEW: STATUS_COLORS[ModelStatus.REVIEW],
  IN_PROCESS_SCALAR_USA: STATUS_COLORS[ModelStatus.IN_PROCESS_SCALAR_USA],
  FINAL: STATUS_COLORS[ModelStatus.FINAL],
  COMPLETE: STATUS_COLORS[ModelStatus.COMPLETE],
  WAITING: STATUS_COLORS[ModelStatus.WAITING],
  BACKGROUND: '#19c2e71a',
  BORDER: '#2185d0',
  LABELS: '#3174ad',
} as const;

// Type for color palette
export type CalendarColorPalette = {
  DRAFT: string;
  REVIEW: string;
  IN_PROCESS_SCALAR_USA: string;
  FINAL: string;
  COMPLETE: string;
  WAITING: string;
  BACKGROUND: string;
  BORDER: string;
  LABELS: string;
};